import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuscarTramiteComponent } from './buscar-tramite/buscar-tramite.component';
import { HomeComponent } from './home/home.component';
import { InfoFirmasComponent } from './info-firmas/info-firmas.component';
import { InicioMatriculacionComponent } from './inicio-matriculacion/inicio-matriculacion.component';
import { LoginComponent } from './login/login.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { ProcesofirmaIniciadoComponent } from './info-procesofirma/iniciado/procesofirma-iniciado.component';
import { ProcesofirmaErrorComponent } from './info-procesofirma/error/procesofirma-error.component';
import { AuthGuard } from './_helpers/auth.guard';
import { PathresolverService } from './_services/pathresolver.service';
import { AltaUsuarioComponent } from './alta-usuario/alta-usuario.component';
import { GestionUsuariosComponent } from './gestion-usuarios/gestion-usuarios.component';
import { EditarUsuarioComponent } from './editar-usuario/editar-usuario.component';
import { VistaQrComponent } from './vista-qr/vista-qr.component';
import { VistaErrorQrComponent } from './vista-error-qr/vista-error-qr.component';
import { NoAutorizadoComponent } from './no-autorizado/no-autorizado.component';


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: "login", component: LoginComponent },
  { path: "home", component: HomeComponent, canActivate: [AuthGuard] },
  { path: "iniciar-matriculacion", component: InicioMatriculacionComponent, canActivate: [AuthGuard] },
  { path: "procesofirma/iniciado", component: ProcesofirmaIniciadoComponent, canActivate: [AuthGuard] },
  { path: "procesofirma/error", component: ProcesofirmaErrorComponent, canActivate: [AuthGuard] },
  { path: "info-firmas", component: InfoFirmasComponent, canActivate: [AuthGuard] },
  { path: "buscar-tramite", component: BuscarTramiteComponent, canActivate: [AuthGuard] },
  { path: "alta-usuario", component: AltaUsuarioComponent, canActivate: [AuthGuard] },
  { path: "gestion-usuarios", component: GestionUsuariosComponent, canActivate: [AuthGuard], data: { roles: ["ADMINISTRADOR"] } },
  { path: "editar-usuario", component: EditarUsuarioComponent, canActivate: [AuthGuard] },
  { path: "validar/:id", component: VistaQrComponent},
  { path: "validar-error", component: VistaErrorQrComponent},
  { path: "no-autorizado", component: NoAutorizadoComponent, canActivate: [AuthGuard] },
  
  {
    path: '**', resolve: {
      path: PathresolverService
    },
    component: NotfoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
